
import { Component, OnInit, computed, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonFieldWidgetBase } from '../common-field-widget-base';
import { CommonRadioField } from '../field';
import { getLabels } from '../field.labels';


@Component({
	selector: 'common-radio-field',
	imports: [FormsModule],
	templateUrl: './common-radio-field.widget.html',
	host: { '[class.d-none]': 'isExcluded()' },
})
export class CommonRadioFieldWidget<T> extends CommonFieldWidgetBase<T, CommonRadioField<T>> implements OnInit {

	public readonly field = input.required<CommonRadioField<T>>();
	public readonly labels = computed(() => getLabels(this.field().config().isSpanish));


	ngOnInit() {
		this.onInit(this.field());
	}


	public onChange(value: T,) {
		this.processChange(value);
	}


	public async onBlur() {
		await this.processBlur();
	}


	protected renderValue(value: T) {
		const pendingValue = this.field().pendingValue() ?? this.field().actualValue();

		if (pendingValue === value) return true;
		else return false;
	}


	protected validate(value: T): string {

		const config = this.field().config();
		const labels = this.labels();

		if (!value && config.isRequired) return labels.missingRequired();
		if (value && !config.options.map(opt => opt.value == value)) return labels.invalidSelection();

		return '';
	}


	public setFocus() {
		console.error('setFocus() not implemented');
	}
	
}